<template>
  <div v-click-outside="close">
    <el-button
      v-if="!isCompleted && isAdmin"
      size="default"
      class="bg-black text-th-warning border-th-warning hover:bg-black hover:text-th-warning-dark-2 hover:border-th-warning-dark-2"
      plain
      @click="showList = !showList"
    >
      {{ $t('common.interactions.buttons.account_setup') }}
    </el-button>
    <div v-show="showList" class="absolute">
      <base-card
        class="p-4 w-full bg-white z-10 mt-2"
        style="min-width: 21rem; max-width: 21rem; margin-left: -192px"
      >
        <a
          v-for="(stage, index) in optionsOrdered"
          :key="stage"
          :class="{
            'bg-th-light-blue hover:bg-th-light-blue-hover': !getStage(stage),
            'bg-th-lighter-green text-th-green hover:bg-th-lighter-green-hover':
              getStage(stage)
          }"
          class="mb-2 flex cursor-pointer rounded"
          @click="triggerOnboardingStep(stage)"
        >
          <div class="flex items-center mx-4">
            <div
              class="rounded-full h-12 w-12 bg-white flex items-center justify-center"
              :class="{ 'text-3xl': getStage(stage) }"
            >
              <check-icon
                v-if="getStage(stage)"
                class="w-6 h-6"
                data-testid="tickIcon"
              />
              <span v-else>{{ index + 1 }}</span>
            </div>
          </div>
          <div class="py-4 pr-4 flex flex-col text-sm">
            <span class="font-semibold" v-text="titleTranslations[stage]" />
            <span v-text="descriptionTranslations[stage]" />
          </div>
        </a>
      </base-card>
    </div>
  </div>
</template>

<script>
import safeGet from 'just-safe-get'
import BaseCard from '@shared/components/base-card'
import { mapWritableState, mapState } from 'pinia'
import { useAuthStore } from '@shared/store/auth'
import { useUiStateStore } from '@shared/store/ui-state'
import { useConfigurationStore } from '@shared/store/configuration'
import { CheckIcon } from '@shared/assets/icons'

export default {
  components: {
    BaseCard,
    CheckIcon
  },
  data() {
    return {
      optionsOrdered: ['account_information', 'branches', 'register', 'staff']
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ['tenantConfig']),
    ...mapState(useAuthStore, ['isAdmin']),
    ...mapWritableState(useUiStateStore, {
      showList: 'showOnboardList',
      isOnboardingRoute: 'isOnboardingRoute'
    }),
    stages() {
      return safeGet(this.tenantConfig, 'onboarding.stages') || []
    },
    isCompleted() {
      return safeGet(this.tenantConfig, 'onboarding.completed') !== false
    },
    titleTranslations() {
      return {
        account_information: this.$t(
          'onboarding.card.account_information.title'
        ),
        branches: this.$t('onboarding.card.branches.title'),
        register: this.$t('onboarding.card.register.title'),
        staff: this.$t('onboarding.card.staff.title')
      }
    },
    descriptionTranslations() {
      return {
        account_information: this.$t(
          'onboarding.card.account_information.description'
        ),
        branches: this.$t('onboarding.card.branches.description'),
        register: this.$t('onboarding.card.register.description'),
        staff: this.$t('onboarding.card.staff.description')
      }
    }
  },
  methods: {
    open() {
      this.showList = true
    },
    close() {
      this.showList = false
    },
    getStage(stage) {
      return this.stages[stage] || null
    },
    triggerOnboardingStep(step) {
      // Let the page know that we are redirecting from onboarding
      this.isOnboardingRoute = true
      switch (step) {
        case 'branches':
          this.$router.push({ name: 'resources-branches' })
          break
        case 'staff':
          this.$router.push({ name: 'staff-list' })
          break
        case 'account_information':
          this.$router.push({ name: 'account' })
          break
        case 'register':
          this.$router.push({ name: 'resources-registers-all' })
          break
      }
      this.close()
    }
  }
}
</script>

<style>
.complete {
  fill: var(--color-complete) !important;
}
</style>
